import { useGlobal } from "reactn";
import { useUserPremiumState } from "@ugg/shared/api/requests/accounts/user-state";

export function useAdFree() {
  const [loggingIn] = useGlobal("loggingIn");
  const { data, loading } = useUserPremiumState();

  return loading || loggingIn || !!data?.isPremium;
}
